import { render, staticRenderFns } from "./NavBar-pc.vue?vue&type=template&id=63653538&scoped=true&"
import script from "./NavBar-pc.vue?vue&type=script&lang=js&"
export * from "./NavBar-pc.vue?vue&type=script&lang=js&"
import style0 from "./NavBar-pc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NavBar-pc.vue?vue&type=style&index=1&id=63653538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63653538",
  null
  
)

export default component.exports